import * as R from 'Router/routes';
import ValidationError, { FieldError } from './ValidationError';

export const routesWithAlreadyExistErrMsgManaged = [R.PERSONAL_DETAILS];

export const isAlreadyExistErrorMsg = (e: ValidationError) =>
  e.fieldErrors.some((error: FieldError) => {
    return error.messageTemplate === 'failed_to_complete_the_operation';
  });

export const ERRORS_TEMPLATES = {
  INCORRECT_CODE: 'incorrect_code',
};

export const isErrorTemplate = (e: unknown, errorTemplate: string) => {
  if (!(e instanceof ValidationError)) return false;
  return Boolean(
    e.fieldErrors.find(
      ({ messageTemplate }) => messageTemplate === errorTemplate,
    ),
  );
};
